<div class="col-md-12">
  <br />
  <div class="row do-not-print">
    <div class="col-md-12 text-right">
      <button mat-raised-button class="btn-primary" click="window.print();return false;">Print</button>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="odp-xs-card-margin-top col-print-12">
      <div class="card">
        <div class="card-body text-left">
          <div class="row">
            <div class="col-md-4">
              <span><b>User ID:</b>  {{userName}}</span>
            </div>
            <div class="col-md-4">
              <span><b>Date:</b>  {{data.abstract.lastModifiedDate | date}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span><b>Project Title:</b>  {{data.abstract.projectTitle | titlecase}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span><b>Administering IC:</b>  {{data.abstract.ic}}</span>
            </div>
            <div class="col-md-6">
              <span><b>Application ID:</b>  {{data.abstract.application}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span><b>PI Project Leader:</b>  {{data.abstract.piprojectLeader | titlecase}}</span>
            </div>
            <div class="col-md-2">
              <span><b>FY:</b>  {{data.abstract.fy}}</span>
            </div>
            <div class="col-md-4">
              <span><b>Project Number:</b>  {{data.abstract.projectNumber}}</span>
            </div>
          </div>
          <hr />
          <b>Description:</b>
          <p>{{data.abstract.abstractText.descPart}}</p>
          <hr />
          <b>Public Health Relevance:</b>
          <p>{{data.abstract.abstractText.publicHealthPart}}</p>
        </div>
      </div>
      <br />
      <div class="card" *ngIf="data.notes">
        <div class="card-body text-left">
          <h5>Notes</h5>
          <div class="d-print-none">
            <mat-form-field style="width:50% !important">
              <textarea row="3" matInput placeholder="Add Note" [(ngModel)]="note.notePlain"></textarea>
            </mat-form-field>
            <button mat-button class="btn btn-success" style="margin-left:10px;" (click)="saveNote()">Save</button>
          </div>
          <div *ngFor="let note of data.notes | sort:'lastModifiedDate':'desc'">
            <span *ngIf="note.parentNoteId == null">
              <hr />
              <span *ngIf="note != null && note.applicationUser !=null && note.applicationUser.friendlyName !=null" class="noteMetadata">{{note.lastModifiedDate | date}} - {{note.applicationUser.firstName}} {{note.applicationUser.lastName}}:</span>
              <span *ngIf="note.applicationUser == null || note.applicationUser.friendlyName ==null" class="noteMetadata">Just now:</span>
              <br />
              <span>{{note.notePlain}}</span>
            </span>
            <div class="subNote" *ngFor="let childNote of data.notes">
              <span *ngIf="childNote.id == note.parentNoteId ">
                <span class="noteMetadata">{{childNote.lastModifiedDate | date}} - {{note.applicationUser.firstName}} {{note.applicationUser.lastName}} :</span>
                <br />
                <span>{{childNote.notePlain}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

